import { map } from 'lodash';
import { Err, Ok } from 'ts-results-es';
import { z } from 'zod';

import {
  alertsV1NotifyConfigsDeleteDestroy,
  alertsV1NotifyConfigsListRetrieve,
  alertsV1NotifyConfigsNewCreate,
  alertsV1NotifyConfigsUpdateUpdate,
  type ListNotifyConfigViewOutput,
} from '@/api/fe-api/__generated__/oazapfts-client';

import type { BodyOf } from '..';
import { AlertNotificationRuleSchema } from '../domain/entities/alert-notifications';
import type { IAlertNotificationRepository } from '../domain/repositories/alert-notification-respository';

import { notificationRuleMapper } from './entities/alert-notification/notification-rule.mapper';

export namespace AlertNotificationRepositoryMapper {
  export namespace getAll {
    export const outputSchema = z.array(AlertNotificationRuleSchema);

    export function bodyFromInput(
      _input: IAlertNotificationRepository.GetAllInput,
    ): BodyOf<typeof alertsV1NotifyConfigsListRetrieve> {
      return {};
    }

    export function outputFromData(
      data: ListNotifyConfigViewOutput,
    ): IAlertNotificationRepository.GetAllOutput {
      try {
        return Ok(
          map(
            data.notify_configs.filter((item) => item.visible),
            notificationRuleMapper,
          ),
        );
      } catch (_error) {
        return Err({
          type: 'EXTERNAL_ERROR',
          description: 'Mismatched types',
        });
      }
    }
  }

  export namespace create {
    export const outputSchema = z.array(AlertNotificationRuleSchema);

    export function bodyFromInput(
      input: IAlertNotificationRepository.CreateInput,
    ): BodyOf<typeof alertsV1NotifyConfigsNewCreate> {
      return {
        createNotifyConfigViewInputSeralizerRequest: {
          name: input.description ?? '',
          minimum_alert_level: input.minAlertStatus,
          site_accure_ids: input.siteIds,
          frequency: input.frequency,
          recipient_emails: input.externalEmails,
          active: input.isEnabled,
          visible: true,
        },
      };
    }
  }

  export namespace updateById {
    export const outputSchema = z.array(AlertNotificationRuleSchema);

    export function bodyFromInput(
      input: IAlertNotificationRepository.UpdateInput,
    ): BodyOf<typeof alertsV1NotifyConfigsUpdateUpdate> {
      if ('externalEmails' in input) {
        return {
          uuid: input.id,
          updateNotifyConfigViewInputSeralizerRequest: {
            minimum_alert_level: input.minAlertStatus,
            site_accure_ids: input.siteIds,
            frequency: input.frequency,
            recipient_emails: input.externalEmails,
            active: input.isEnabled,
          },
        };
      }

      return {
        uuid: input.id,
        updateNotifyConfigViewInputSeralizerRequest: {
          active: input.isEnabled,
        },
      };
    }
  }

  export namespace deleteById {
    export const outputSchema = z.array(AlertNotificationRuleSchema);

    export function bodyFromInput(
      input: IAlertNotificationRepository.DeleteInput,
    ): BodyOf<typeof alertsV1NotifyConfigsDeleteDestroy> {
      return {
        uuid: input.id,
      };
    }
  }
}
